// src/scripts/contact/internal/constants.js

// Detect runtime environment
export const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

// Key used to flag that the contact system has been loaded
export const CONTACT_LOADED_KEY = '__CONTACT_SYSTEM_LOADED__';

// Flag used to toggle debug mode on the contact system
export const DEBUG_KEY = '__CONTACT_DEBUG_ENABLED__';

// DOM ready states for convenience
export const DOM_READY_STATES = {
  LOADING: 'loading',
  INTERACTIVE: 'interactive',
  COMPLETE: 'complete'
};